import { useContext } from 'react';
import { SearchableContext } from '../SearchableContext';

export function useSearchableContext() {
	const context = useContext(SearchableContext);

	return context;
}
